import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9008Model } from './kymw9008.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { LoginUserInfoModel } from '../../kymw10/kymw1000/vo/login-user-info.model';
import { Router } from '@angular/router';
import { CheckMfaService } from './api-services/check-mfa.service';

/**
 * 2要素認証画面
 *
 * @export KYMW9008Component
 * @class KYMW9008Component
 */
@Component({
  selector: 'app-kymw9008',
  templateUrl: 'kymw9008.component.html',
  styleUrls: ['kymw9008.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9008Component extends PlessViewHelperSub implements OnInit {

  public model: KYMW9008Model = new KYMW9008Model();

  /**
   *Creates an instance of KYMW9008Component.
   * @param {KYMW00Model} kymw00Model
   * @param {Router} router
   * @memberof KYMW9008Component
   */
  constructor(
    public kymw00Model: KYMW00Model,
    public checkMfaService: CheckMfaService,
    private router: Router,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9008Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9008';
  }

  /**
   * 戻るボタンを押した時のイベント
   * 
   * @memberof KYMW9008Component
   */
  public eventReturnHanler(): void {
    this.router.navigate(['/login']);
  }

  /**
   * 認証ボタンを押した時のイベント
   */
  public eventCheckMfaHandler(): void {
    this.checkMfaService.execute(this.model, (data: any) => {
      this.afterLogin(data);
    });
  }

  afterLogin(data: LoginUserInfoModel) {
    this.kymw00Model.kymw1001Model.loginUserInfo.UserID = data.UserID;
    this.router.navigate(['/kymw/1002']);
  }
}
